import { render, staticRenderFns } from "./addCityAdmin.vue?vue&type=template&id=5468e6f4&scoped=true&"
import script from "./addCityAdmin.vue?vue&type=script&lang=js&"
export * from "./addCityAdmin.vue?vue&type=script&lang=js&"
import style0 from "./addCityAdmin.vue?vue&type=style&index=0&id=5468e6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5468e6f4",
  null
  
)

export default component.exports